import type { LogEntry } from '../phase1/types';

function escapeCsv(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`;
  }
  return value;
}

export function entriesToCsv(entries: LogEntry[]): string {
  const header = ['uid', 'timestamp'];
  const lines = [header.join(',')];
  for (const entry of entries) {
    lines.push([escapeCsv(entry.uid), escapeCsv(entry.timestamp)].join(','));
  }
  return lines.join('\n');
}
